import React from "react";
import { Skeleton } from "../../Components/Needed";

const STAGES = ["Initiated", "Booked", "Started", "Ended", "Completed", "Pending", "Closed", "Cancelled"];

// Ordered horizontal bars rather than a pie/donut - these 8 buckets are a
// pipeline (a booking moves left to right through them), not an unordered
// breakdown, so a funnel-style list reads correctly and keeps every label
// legible regardless of how lopsided the counts are.
const StageFunnel = ({ byStage, loading }) => {
    if (loading) {
        return (
            <div>
                {STAGES.map((stage) => <Skeleton key={stage} height={18} className="mb-3" />)}
            </div>
        );
    }

    const counts = byStage || {};
    const max = Math.max(1, ...STAGES.map((stage) => Number(counts[stage] || 0)));
    const total = STAGES.reduce((sum, stage) => sum + Number(counts[stage] || 0), 0);

    if (!total) {
        return <div className="mini-table-empty">No bookings yet.</div>;
    }

    return (
        <div>
            {STAGES.map((stage) => {
                const value = Number(counts[stage] || 0);
                const width = Math.max(2, (value / max) * 100);
                return (
                    <div className={`stage-bar-row stage-${stage}`} key={stage}>
                        <span className="stage-bar-label"><span className="stage-dot" />{stage}</span>
                        <span className="stage-bar-track"><span className="stage-bar-fill" style={{ width: `${width}%` }} /></span>
                        <span className="stage-bar-count">{value.toLocaleString()}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default StageFunnel;
